import { render, staticRenderFns } from "./diyshop.vue?vue&type=template&id=f05d84e6&scoped=true&"
import script from "./diyshop.vue?vue&type=script&lang=js&"
export * from "./diyshop.vue?vue&type=script&lang=js&"
import style0 from "./diyshop.vue?vue&type=style&index=0&id=f05d84e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05d84e6",
  null
  
)

export default component.exports